import { Injectable, signal } from "@angular/core";

@Injectable({
  providedIn: 'root'
})
export class LandingPageService {

  private _campaignSignal = signal<any | null>(null);

  campaign = this._campaignSignal.asReadonly();

  setCampaign(data: any) {
    this._campaignSignal.set(data);
  }

  getCampaign() {
    return this._campaignSignal();
  }

}